import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 288px;
`;

const Title = styled.h3`
  font-weight: 300;
  font-size: 16px;
  color: #171c3c;
`;

const Amount = styled.div<{ color: string }>`
  color: ${(props) => props.color};
  font-size: 20px;
  font-weight: 500;
`;

type Props = {
  title: string;
  amount: string;
  children?: React.ReactNode;
  color?: string;
};

export function Balance({ title, amount, color = '#171c3c', children }: Props) {
  return (
    <Container>
      <Title>{title}</Title>
      <Spacer vertical spacing={2} />
      <Amount color={color}>{amount}</Amount>
      <Spacer vertical spacing={3} />
      {children}
    </Container>
  );
}
